module.exports = __webpack_public_path__ + "static/cover-77d6a8763f9574e7bcb1e974e17a54cc.png";